import { useMe } from 'platform-components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import * as lessonSelectors from 'common.components/lesson/selectors';

import { SubscriptionModalModeSubscribe } from './_mode/subscription-modal_mode_subscribe';
import { SubscriptionModalModeUnsubscribe } from './_mode/subscription-modal_mode_unsubscribe';
import * as selectors from './selectors';
import { SUBSCRIPTION_MODAL_MODE } from './typings';

export const SubscriptionModal = () => {
    const { classId, subject } = useParams<{ classId: string; subject: string }>();

    const me = useMe();
    const opened = useSelector(selectors.getIsModalOpened);
    const mode = useSelector(selectors.getModalMode);

    const lessonId = useSelector(lessonSelectors.getLessonId);
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const commonMetrikaData = useMemo(
        () => ({
            teacher_id: me?.id,
            team_id: classId,
            subject,
            lesson_id: lessonId,
            cl_id: clessonId,
        }),
        [me, classId, subject, lessonId, clessonId]
    );

    switch (mode) {
        case SUBSCRIPTION_MODAL_MODE.SUBSCRIBE:
            return <SubscriptionModalModeSubscribe commonMetrikaData={commonMetrikaData} opened={opened} />;
        case SUBSCRIPTION_MODAL_MODE.UNSUBSCRIBE:
            return <SubscriptionModalModeUnsubscribe commonMetrikaData={commonMetrikaData} opened={opened} />;
        default:
            return null;
    }
};
